import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import PageContext from '../../../config/page-settings.js';

import CoinsTransactionsList from './CoinsTransactionsList';

const CoinsTransactions = (props) => {
  const pageContext = useContext(PageContext);

  useEffect(() => {
    pageContext.handleSetPageSidebar(true);
    pageContext.handleSetPageHeader(true);
    pageContext.handleSetPageContentFullWidth(false);
  }, []);

  return (
    <div>
      <h1 className="page-header">CoinsPH Transactions</h1>
      <CoinsTransactionsList />
    </div>
  );
};

export default withRouter(CoinsTransactions);
